import { render } from "./Seminaire.vue?vue&type=template&id=553c23a2&ts=true"
import script from "./Seminaire.vue?vue&type=script&lang=ts"
export * from "./Seminaire.vue?vue&type=script&lang=ts"

import "./Seminaire.vue?vue&type=style&index=0&id=553c23a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__